<div class="bool-answer">
  <app-radio-button class="bool-answer__control">
    <input type="radio" value="1" />
    <radio-button-text>Да</radio-button-text>
  </app-radio-button>

  <app-radio-button class="bool-answer__control">
    <input type="radio" value="0" />
    <radio-button-text>Нет</radio-button-text>
  </app-radio-button>
</div>
